import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const DatabaseService = {
  get(context, clientid) {
    return fetchWithToken(`${config(context).databaseUrl}/latest/?clientid=${clientid}`, {
      method: 'GET',
    }).then((body) => body.json())
  },
}
